module.exports = __webpack_public_path__ + "media/images/link-1-2215c9a5b1acbe9669be1c024d6e8a95.png";